(ns frontend.ui.component.chart.style)

(defn chart-container
  []
  (with-meta
    {:position "relative"}
    {:combinators {[:descendant "#chart-overlay:hover"]
                   {:opacity 100}}}))

(defn chart-overlay
  []
  (with-meta
    {:position        "absolute"
     :opacity         0
     :top             0
     :left            0
     :width           "100%"
     :height          "100%"
     :background      "rgba(0, 0, 0, 0.5)"
     :border-radius   "16px"
     :display         "flex"
     :justify-content "center"
     :align-items     "center"
     :z-index         10
     :transition      "opacity 0.3s ease"}
    {}))

(defn chart-toolbar
  []
  (with-meta
    {:position       "absolute"
     :top            "-42px"
     :right          "-16px"
     :height         "30px"
     :display        "flex"
     :gap            "8px"
     :flex-direction "row"
     :align-items "center"
    }
    {}))


(defn dropdown-trigger
  []
  (with-meta
    {:display        "flex"
     :flex-direction "row"
     :gap            "8px"
     :align-items    "center"
     :white-space    "nowrap"}
    {}))
